import React from 'react';
import { Link } from 'react-router-dom';
import grantService from '../services/grantService';
import './SearchResults.css';

const SearchResults = ({ results, onExport }) => {
  if (!results || !results.records || results.records.length === 0) {
    return null;
  }

  const { records, totalRecords, page, totalPages } = results;

  const handleExport = () => {
    if (onExport && typeof onExport === 'function') {
      onExport(records);
    }
  };

  return (
    <div className="search-results card">
      <h2>Search Results ({totalRecords})</h2>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Grant ID</th>
              <th>Recipient</th>
              <th>Project Title</th>
              <th>Agency</th>
              <th>Amount</th>
              <th>Fiscal Year</th>
            </tr>
          </thead>
          <tbody>
            {records.map(grant => (
              <tr key={grant.GrantID}>
                <td>{grant.GrantID}</td>
                <td>{grant.RecipientName}</td>
                <td>
                  <Link to={`/grant/${grant.GrantID}`}>
                    {grant.ProjectTitle}
                  </Link>
                </td>
                <td>{grant.AgencyDept}</td>
                <td>{grantService.formatCurrency(grant.TotalAwardAmount)}</td>
                <td>{grant.FiscalYear}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="results-footer">
        <button className="button" onClick={handleExport}>Export Results</button>

        <div className="pagination">
          <span>Page {page} of {totalPages}</span>
        </div>
      </div>
    </div>
  );
};

export default SearchResults;